import { TransactionPnvtInfo } from "../../../graphql/graphql_transaction_linkcy/transaction/types/TransactionPnvtInfo";
import { _transactions } from "../../../indexDB/data";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import {
  setTransactions,
  setTxInvalidated,
} from "../../../redux/transaction/transactionSlice";
import { addOrUpdateObject, removeObject } from "../../../utils/utils";

export const useCreateOrUpdateTransactionCache = () => {
  const dispatch = useAppDispatch();
  const { txInvalidated, transactions } = useAppSelector(
    (state) => state.transaction,
  );

  const updateOrCreate = (transaction: TransactionPnvtInfo) => {
    const listValid = addOrUpdateObject(transactions, transaction);
    dispatch(setTransactions([...listValid]));
  };

  const removeInvalid = (id: string | null) => {
    if (id) {
      const listInvalid = removeObject(txInvalidated, { id });
      dispatch(setTxInvalidated([...listInvalid]));
    }
  };

  return { updateOrCreate, removeInvalid };
};
